const hasLoginRegisterLink = (link: string) => {
  if (link === '/login' || link === '/register') {
    return true;
  }
  return false;
};

export default hasLoginRegisterLink;
